import { PopoverInfo } from 'react-tiny-popover';

const getClippingParentTop = (element: HTMLElement): number => {
    let parent = element.parentElement;
    while (parent) {
        const { overflowY } = window.getComputedStyle(parent);
        if (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'hidden') {
            return parent.getBoundingClientRect().top;
        }
        parent = parent.parentElement;
    }
    return 0;
};

export const getModalPosition = (position, align, padding, buttonEl: HTMLElement, optionsModalEl: HTMLElement, autoFlip = false) => {
  if (buttonEl && optionsModalEl) {
      const buttonElRect = buttonEl.getBoundingClientRect();
      const optionsModalElRect = optionsModalEl.getBoundingClientRect();

      const spaceAbove = buttonElRect.top - getClippingParentTop(buttonEl);
      const requiredSpace = optionsModalElRect.height + padding;
      const hasNoSpaceAbove = spaceAbove < requiredSpace;
      const shouldFlipToBottom = autoFlip && position === 'top' && hasNoSpaceAbove;

      const resolvedPosition = shouldFlipToBottom ? 'bottom' : position;

      const centerX = 0 - (optionsModalElRect.width / 2 - buttonElRect.width / 2);
      const centerY = 0 - (optionsModalElRect.height / 2 - buttonElRect.height / 2);
      let left = centerX;
      let top = centerY;

      switch (resolvedPosition) {
          case 'left':
              left -= optionsModalElRect.width / 2 + buttonElRect.width / 2 + padding;
              break;
          case 'right':
              left += optionsModalElRect.width / 2 + buttonElRect.width / 2 + padding;
              break;
          case 'top':
              top -= optionsModalElRect.height / 2 + buttonElRect.height / 2 + padding;
              break;
          case 'bottom':
              top += optionsModalElRect.height / 2 + buttonElRect.height / 2 + padding;
              break;
      }

      switch (align) {
          case 'start':
              if (resolvedPosition === 'left' || resolvedPosition === 'right') {
                  top += optionsModalElRect.height / 2 - buttonElRect.height / 2;
              } else {
                  left -= buttonElRect.width / 2 - optionsModalElRect.width / 2;
              }
              break;
          case 'end':
              if (resolvedPosition === 'left' || resolvedPosition === 'right') {
                  top -= optionsModalElRect.height / 2 - buttonElRect.height / 2;
              } else {
                  left += buttonElRect.width / 2 - optionsModalElRect.width / 2;
              }
              break;
      }
      return { top: top, left: left };
  }
};

export const getPopoverPosition = (buttonElement: HTMLElement, args: PopoverInfo) => {
    const { popoverRect, position, align, nudgedLeft, nudgedTop } = args;
    const offsetLeft = 10;

    if (buttonElement) {
        const buttonRect = buttonElement.getBoundingClientRect();

        let positionLeft = nudgedLeft;

        if (position === 'left') {
            positionLeft = buttonRect.left - popoverRect.width - offsetLeft;
        } else if (position === 'bottom' || position === 'top') {
            if (align === 'end') {
                positionLeft = buttonRect.right - popoverRect.width;
            } else if (align === 'center') {
                positionLeft = buttonRect.left + (buttonRect.width - popoverRect.width) / 2;
            } else if (align === 'start') {
                positionLeft = buttonRect.left;
            } else {
                positionLeft = buttonRect.left + popoverRect.width;
            }
        }

        return {
            top: nudgedTop,
            left: positionLeft
        };
    }
};

export const isClickedOutside = (modalRef, buttonRef, event: MouseEvent) => {
    return modalRef.current && !modalRef.current.contains(event.target) && !buttonRef.current.contains(event.target);
};
